module.exports = __webpack_public_path__ + "src/assets/downloading_scan_history.png";